export type AerodromeRoutePoolArgument = [string, string, boolean, string];

export type AerodromeRoutesMethodArgument = [string, AerodromeRoutePoolArgument[]];
